import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';

import { ReactHookFormInput } from 'common/components/form';

const Parameters = ({ control, disabled, setValue }) => {
    const [productId, parameters] = useWatch({
        control,
        name: ['id', 'parameters'],
    });
    const isNewRecord = !productId;
    const { disabled_credentials, secret_key } = parameters || {};

    return (
        <Box sx={{ alignItems: 'center', display: 'flex' }}>
            <ReactHookFormInput
                control={control}
                disabled={disabled || disabled_credentials}
                label="Secret Key"
                name="secret_key"
            />
            <IconButton
                onClick={() => {
                    setValue('secret_key', null);
                    setValue('disabled_credentials', false);
                }}
                sx={{ ml: 2 }}
                visible={!isNewRecord && secret_key}
            >
                <EditIcon />
            </IconButton>
        </Box>
    );
};

Parameters.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default Parameters;
